import { createContext } from 'react';
const RepairingContext = createContext({});

export default RepairingContext;
